import React from "react";
import style from "./EarningsLoader.module.sass";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { StylesProvider } from "@material-ui/core";

const EarningsLoader = ({ cards }) => {
    return Array(cards)
        .fill(0)
        .map((_, i) => (
            <SkeletonTheme key={i}>
                <div className={style.skeleton} key={i}>
                    <div className={style.section}>
                        <div className={style.contentTech}>
                            <Skeleton width={200} height={40} className={style.text} />
                            <Skeleton className={style.first_section} width={`100%`} height={200} />
                        </div>
                        <div className={style.contentTech}>
                            <Skeleton width={0} height={40} className={style.text} />
                            <Skeleton className={style.first_section} width={`100%`} height={200} />
                        </div>
                        <div className={style.contentTech}>
                            <Skeleton width={0} height={40} className={style.text} />
                            <Skeleton className={style.first_section} width={`100%`} height={200} />
                        </div>
                    </div>
                </div>
            </SkeletonTheme>
        ));
};

export default EarningsLoader;